export default __webpack_public_path__ + "static/tauseef-0ebbc7231ba092956ef477a2b317e2c1.png";